module.exports = __webpack_public_path__ + "static/img/7.9ace520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/7.jpg
// module id = HbqG
// module chunks = 1